import React from "react";
import { useDispatch } from "react-redux";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { setShowUserProfileSidebar } from "../../../../../actions/userProfileSidebar";
import { icon, label } from "../../../../../config";

/**
 * UserProfileSidebarHeader component
 * Contains the header with close button
 * @author Bhavana
 */
const UserProfileSidebarHeader = () => {
  const dispatch = useDispatch();

  /**
   * Closes the UserProfileSidebar
   * @author Bhavana
   */
  const handleCloseSidebar = () => {
    dispatch(setShowUserProfileSidebar({ showUserProfileSidebar: false }));
  };

  return (
    <div className="user-profile-sidebar-header d-flex align-items-center justify-content-between px-3 py-2 border-bottom">
      <div className="header-title">
        <h5 className="mb-0 font-weight-medium">Profile</h5>
      </div>
      <Tooltip anchorElement="target" position="left" parentTitle="true">
        <button
          className="d-flex border-0 outline-none ml-2 bg-transparent cursor-pointer user-profile-close-btn p-1"
          onClick={handleCloseSidebar}
          title={label.CLOSE}>
           {icon.ARROW_FORWARD}
        </button>
      </Tooltip>
    </div>
  );
};

export default UserProfileSidebarHeader;

